//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const AUTH_ADMIN_API_BASE_URL = new InjectionToken<string>('AUTH_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminTokenClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(AUTH_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    login(request: LoginPasswordTokenRequestDto): Observable<TokenResponseDto> {
        let url_ = this.baseUrl + "/admin/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponseDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<TokenResponseDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminTokenProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminTokenClient.Login');
            }));
        }
        return _observableOf(null as any);
    }

    logout(request: LogOutRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminTokenClient.Logout');
            }));
        }
        return _observableOf(null as any);
    }

    refresh(request: RefreshTokenRequestDto): Observable<TokenResponseDto> {
        let url_ = this.baseUrl + "/admin/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponseDto>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<TokenResponseDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminTokenProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminTokenClient.Refresh');
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminUsersClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(AUTH_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<AdminUserDto[]> {
        let url_ = this.baseUrl + "/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdminUserDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.GetAll');
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateAdminUserRequestDto): Observable<AdminUserDto> {
        let url_ = this.baseUrl + "/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdminUserDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AdminUserDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.Create');
            }));
        }
        return _observableOf(null as any);
    }

    changeRole(userId: string, request: ChangeAdminRoleRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/users/{userId}/role";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.ChangeRole');
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(userId: string, request: ResetAdminPasswordRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/users/{userId}/password";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.ResetPassword');
            }));
        }
        return _observableOf(null as any);
    }

    block(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/admin/users/{userId}/block";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.Block');
            }));
        }
        return _observableOf(null as any);
    }

    unblock(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/admin/users/{userId}/unblock";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminUserProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminUsersClient.Unblock');
            }));
        }
        return _observableOf(null as any);
    }
}

export class TokenResponseDto implements ITokenResponseDto {
    accessToken!: string | undefined;
    refreshToken!: string | undefined;

    constructor(data?: ITokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITokenResponseDto {
    accessToken: string | undefined;
    refreshToken: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class XProblemDetailsOfAdminTokenProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminTokenProblemCode {
    problemCode!: AdminTokenProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminTokenProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminTokenProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminTokenProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminTokenProblemCode extends IProblemDetails {
    problemCode: AdminTokenProblemCode;

    [key: string]: any;
}

export enum AdminTokenProblemCode {
    WrongCredentials = "WrongCredentials",
    TokenRefreshFailed = "TokenRefreshFailed",
    RefreshTokenExpired = "RefreshTokenExpired",
    UserIsBlocked = "UserIsBlocked",
}

export class LoginPasswordTokenRequestDto implements ILoginPasswordTokenRequestDto {
    login!: string;
    password!: string;

    constructor(data?: ILoginPasswordTokenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginPasswordTokenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginPasswordTokenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginPasswordTokenRequestDto {
    login: string;
    password: string;
}

export class RefreshTokenRequestDto implements IRefreshTokenRequestDto {
    accessToken!: string;
    refreshToken!: string;

    constructor(data?: IRefreshTokenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequestDto {
    accessToken: string;
    refreshToken: string;
}

export class LogOutRequestDto implements ILogOutRequestDto {
    refreshToken!: string | undefined;

    constructor(data?: ILogOutRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): LogOutRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogOutRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILogOutRequestDto {
    refreshToken: string | undefined;
}

export class AdminUserDto implements IAdminUserDto {
    id!: string;
    userName!: string | undefined;
    role!: AdminRole;
    isBlocked!: boolean;

    constructor(data?: IAdminUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            this.isBlocked = _data["isBlocked"];
        }
    }

    static fromJS(data: any): AdminUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["role"] = this.role;
        data["isBlocked"] = this.isBlocked;
        return data;
    }
}

export interface IAdminUserDto {
    id: string;
    userName: string | undefined;
    role: AdminRole;
    isBlocked: boolean;
}

export enum AdminRole {
    Undefined = 0,
    Admin = 1,
    Moderator = 2,
    Translator = 3,
}

export class XProblemDetailsOfAdminUserProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminUserProblemCode {
    problemCode!: AdminUserProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminUserProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminUserProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminUserProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminUserProblemCode extends IProblemDetails {
    problemCode: AdminUserProblemCode;

    [key: string]: any;
}

export enum AdminUserProblemCode {
    UserNotFound = "UserNotFound",
    UserAlreadyExists = "UserAlreadyExists",
    CreationFailed = "CreationFailed",
}

export class CreateAdminUserRequestDto implements ICreateAdminUserRequestDto {
    userName!: string;
    password!: string;
    role!: AdminRole;

    constructor(data?: ICreateAdminUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateAdminUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdminUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["role"] = this.role;
        return data;
    }
}

export interface ICreateAdminUserRequestDto {
    userName: string;
    password: string;
    role: AdminRole;
}

export class ChangeAdminRoleRequestDto implements IChangeAdminRoleRequestDto {
    role!: AdminRole;

    constructor(data?: IChangeAdminRoleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ChangeAdminRoleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeAdminRoleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        return data;
    }
}

export interface IChangeAdminRoleRequestDto {
    role: AdminRole;
}

export class ResetAdminPasswordRequestDto implements IResetAdminPasswordRequestDto {
    newPassword!: string;

    constructor(data?: IResetAdminPasswordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetAdminPasswordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAdminPasswordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetAdminPasswordRequestDto {
    newPassword: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}